import GetPricingMapper from '@/modules/dental/hiring/mappers/MID/GetPricingMapper'

export default {
  GetPricingMapper
}
